export default __webpack_public_path__ + "static/media/discounts-10off25-image.a6ced55a.svg";